<script>
  import ClickOut from '../../../../utils/directives/clickout'
  import MenuItem from '../MenuItem'

export default{
    components: {MenuItem},
    data () {
      return {
        open: false
      }
    },
    computed: {},
    mounted () {
      this.popupItem = this.$el
    },
    methods: {
      toggle () {
        this.open = !this.open
      },
      hide () {
        this.open = false
      },
      clicked: function (e) {
        console.log('prevented!')
        e.preventDefault()
      }
    },
    directives: {ClickOut}
  }
</script>

<template>
  <li :class="{ active: open }">
    <a v-click-out="hide" @click="toggle" class="auto">
      <span class="pull-right text-muted">
      <i class="fa fa-fw fa-angle-right text"></i>
      <i class="fa fa-fw fa-angle-down text-active"></i>
      </span>
      <i class="fa fa-gavel text-warning icon"></i>
      <span>Leilão</span>
    </a>
    <ul class="nav nav-sub dk">
      <li class="nav-sub-header"><a><span class="text-muted teste">Website</span></a></li>
      <menu-item :to="{ name: 'leilao' }" show>Leilões</menu-item>
      <menu-item :to="{ name: 'leilao.historico.leiloes.veiculo' }" show>Pesquisar veículo</menu-item>
    </ul>
  </li>
</template>



// WEBPACK FOOTER //
// Leilao.vue?3f1556f0